/**
 * @param {Object} state - Redux state containing `disabilityRating`
 * @returns {number} the total disability rating, defaulting to `0`
 */
export const selectTotalDisabilityRating = state =>
  parseInt(state.disabilityRating.totalRating, 10) || 0;
